import { type TPlan as TApiPlan, getPlanUrl } from '@core/api'
import { httpClient } from '@core/http-client'

import { convertPlan } from '@core/converters'

export const getPlan = async (params: { signal?: AbortSignal } = {}) => {
    const apiPlan = await httpClient
        .get(getPlanUrl(), {
            signal: params.signal,
        })
        .json<TApiPlan>()

    return convertPlan(apiPlan)
}
